import React, { useState } from "react";
import styled, { css } from "styled-components";
import { ItemLabel, ItemTitle } from "sweet-web/components/universal/Text";
import { colors } from "sweet-web/lib/styles";

const Wrapper = styled.div`
  padding: 10px 0 10px 0;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

export const globalInputStyles = css`
  -webkit-appearance: none;
  padding: 7px 10px;
  background-color: ${colors.white};
  font-size: 14px;
  font-weight: 500;
  color: ${colors.nearBlack};
  outline: none;
  border-radius: 5px;
  border: 1px solid ${colors.lightGray};
  max-width: 500px;
  transition: all 100ms cubic-bezier(0.21, 0.94, 0.64, 0.99);
  &::placeholder {
    color: ${colors.gray};
  }
  &:hover,
  &:focus {
    box-shadow: rgba(0, 0, 0, 0.08) 0 3px 10px 0;
    &::placeholder {
      color: ${colors.nearBlack};
    }
  }
`;

export const IconWrapper = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 10px 15px 15px;
`;

const Input = styled.input`
  ${globalInputStyles}
  width: 100%;
`;

const MultilineInput = styled.textarea`
  ${globalInputStyles}
  min-height: 100px;
  width: 100%;
  margin-top: 5px;
  resize: vertical;
`;

export type Props = {
  title?: string;
  description?: string;
  placeholder?: string;
  value: string;
  type?: string;
  icon?: any;
  onChange: (value: string) => void;
  onBlur?: () => void;
  multiline?: boolean;
  style?: object;
};
const CustomInput: React.FC<Props> = ({
  type,
  onChange,
  onBlur,
  icon,
  description,
  placeholder,
  title,
  value,
  multiline,
  style,
  ...props
}) => {
  const [focus, setFocus] = useState(false);

  return (
    <Wrapper style={style}>
      {title && <ItemTitle>{title}</ItemTitle>}
      {description && <ItemLabel>{description}</ItemLabel>}
      {!multiline && (
        <Input
          value={value}
          type={type || "text"}
          onChange={(e: { target: { value: string } }) =>
            onChange(e.target.value)
          }
          onFocus={() => setFocus(true)}
          onBlur={() => {
            setFocus(false);
            if (onBlur) onBlur();
          }}
          placeholder={placeholder ? placeholder : ""}
          {...props}
          style={icon ? { paddingLeft: 35 } : {}}
        />
      )}
      {multiline && (
        <MultilineInput
          {...props}
          onChange={(e: { target: { value: string } }) =>
            onChange(e.target.value)
          }
          onFocus={() => setFocus(true)}
          onBlur={() => {
            setFocus(false);
            if (onBlur) onBlur();
          }}
          placeholder={placeholder ? placeholder : ""}
          value={value}
        />
      )}
      {icon && <IconWrapper>{icon}</IconWrapper>}
    </Wrapper>
  );
};
CustomInput.defaultProps = {
  multiline: false,
  style: {}
};

export default CustomInput;
